if (!customElements.get("our-brands")) {
  class OurBrands extends HTMLElement {
    constructor() {
      super();

      this.splide;
      this.brandLogosEl = this.querySelector(".brand-logos");

      this.addEventListener("shopify:section:load", this.createSplide());
      this.addEventListener("shopify:section:unload", this.destroySplide());
    }

    connectedCallback() {
      this.createSplide();
    }

    createSplide() {
      this.splide = new Splide(this.brandLogosEl, {
        type: "slide", // Ensure the type is set to 'slide'
        perPage: 5, // Default setting for desktop
        perMove: 1,
        rewind: false,
        arrows: false,
        pagination: true,
        gap: "2.5rem",
        breakpoints: {
          768: {
            // Settings for mobile screens
            perPage: 3,
            perMove: 1,
            gap: "0.75rem",
          },
        },
      });

      this.splide.mount();
    }

    destroySplide() {
      this.splide.destroy();
    }
  }

  customElements.define("our-brands", OurBrands);
}
